import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export function PanelHeader({
  title,
  description,
  actions,
  className,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        "flex shrink-0 flex-col gap-1.5 border-b border-border px-4 py-3",
        className
      )}
    >
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
        <h2 className="min-w-0 text-sm font-semibold tracking-tight text-foreground sm:whitespace-nowrap">
          {title}
        </h2>
        {actions ? (
          <div className="ml-auto flex min-w-0 flex-wrap items-center justify-end gap-1.5">
            {actions}
          </div>
        ) : null}
      </div>
      {description ? (
        <p className="max-w-[68ch] text-xs leading-relaxed text-muted-foreground">
          {description}
        </p>
      ) : null}
    </header>
  );
}
